import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { paramDeger } from '@/src/app/shared/utils/param-deger.utils';

@Component({
  selector: 'vardiya-devir-kart-sade',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="sk" style="--sk-accent:#13c2c2">
      <div class="sk-icerik">
        <div class="sk-baslik">{{ deger('vardiya') || 'Vardiya' }}</div>
        <div class="sk-alt">{{ deger('devreden') || '?' }} → {{ deger('devralan') || '?' }}</div>
        <div class="sk-stat">
          @if (deger('makineDurumu')) { <span>Makine: <b>{{ deger('makineDurumu') }}</b></span> }
          <span>Uretim: <b>{{ deger('uretimAdedi') || 0 }}</b></span>
          <span>Fire: <b>{{ deger('fireAdedi') || 0 }}</b></span>
        </div>
      </div>
    </div>
  `,
})
export class VardiyaDevirKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  deger(alan: string): any { return paramDeger(this.p(), alan); }
}
